export default __webpack_public_path__ + "static/media/1.c3f2feee.mp4";